'use strict';

$('#newsletter_signup').on('submit', function (e) {
    var _this = this;

    e.preventDefault();
    new Promise(function (resolve, reject) {
        initReCaptcha($(e.target), resolve);
    }).then(function () {
        postFormData($(e.target), $(_this));
    });
});

$('.modal-form form').on('submit', function (e) {
    var _this2 = this;

    e.preventDefault();
    $(this).find('[name=newsletter]').next('label').css('color', 'black');
    if ($(this).find('[name=newsletter]').is(':checked')) {
        new Promise(function (resolve, reject) {
            initReCaptcha($(e.target), resolve);
        }).then(function () {
            postFormData($(e.target), $(_this2), false);
        });
    } else {
        $(this).find('[name=newsletter]').next('label').css('color', '#ed3823');
    }
    return false;
});

function initReCaptcha($form, _callback) {
    var captcha_code = $('#g_captcha_site_key').val();
    var fid = $form.attr('id').toString();
    var actionName = fid.replace('-', '_');
    grecaptcha.ready(function () {
        grecaptcha.execute(captcha_code, { action: actionName }).then(function (token) {
            $form.find('.recaptcha_response').val(token);
            _callback();
        });
    });
}

function postFormData(submittedForm, formElm) {
    var isFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    $('.loader-wrapper ').show();
    submittedForm.remove('.agree-checkbox');
    var postData = new FormData(submittedForm[0]);
    postData.delete('newsletter');
    $.ajax({
        method: 'POST',
        url: formElm.attr('action'),
        data: postData,
        contentType: false,
        cache: false,
        processData: false,
        crossDomain: true,
        success: function success(res) {
            if (isFooter) {
                $('.enews .title').hide('slow', function () {});
                $('.enews .title--success').show('slow', function () {});
            } else {
                $('.signup-modal .modal-text').hide();
                $('.signup-modal .modal-text.success').show();
            }
            formElm.hide();
            $('.loader-wrapper ').hide();
        },
        error: function error(err) {
            $('.loader-wrapper ').hide();
        }
    });
}

$(document).ready(function () {
    // redefine modal newsletter form
    var appendHtml = $('.enews-form .modal-checkbox').html();
    var submitButton = $('.modal-form .btn-ghost--white');
    submitButton.before(appendHtml);
    submitButton.removeClass('btn-ghost').removeClass('btn-ghost--white').addClass('btn--red');
    var btnText = submitButton.text();
    submitButton.text('');
    submitButton.html('<span>' + btnText + '</span>');

    //check for optin-thankyou modal
    if (window.location.hash === '#subscription-success') {
        $('body').addClass('is-modal-open');
        $('.modal.success-form').addClass('is-open');
        window.location.hash = '';
    }
});